import { render, staticRenderFns } from "./LaboratoryDefaultValueSettings.vue?vue&type=template&id=60a0e22a&scoped=true&"
import script from "./LaboratoryDefaultValueSettings.vue?vue&type=script&lang=js&"
export * from "./LaboratoryDefaultValueSettings.vue?vue&type=script&lang=js&"
import style0 from "./LaboratoryDefaultValueSettings.vue?vue&type=style&index=0&id=60a0e22a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a0e22a",
  null
  
)

export default component.exports